module.exports = __webpack_public_path__ + "img/@tmp_facility_list_04.74dcc343.jpg";